export const FeaturedCountries = [
  'at',
  'be',
  'ch',
  'de',
  'es',
  'fr',
  'is',
  'it',
  'nl',
  'pt',
];
